/**
 * package: com.inq.ui
 * class: Text
 * @extends com.inq.ui.TextInput 
 * @constructor
 */
com.inq.ui.Text = function(text) {
	com.inq.ui.TextInput.call(this);
	this._div.innerHTML = "<span style=\"height:100%;width:100%\"></span>";
	this._text = this._div.getElementsByTagName("SPAN")[0];
	this._updatable = true;
	
	if(text != null) this.setText(text);
};
$hxClasses.extend(com.inq.ui.TextInput, com.inq.ui.Text, "com.inq.ui.Text");

/**
 * applyAttributeMap - is used to set attributes for a Text component
 * return {void}
 */
com.inq.ui.Text.prototype.applyAttributeMap = function() {
	for (var aKey in this.attributeMap) {
		if (this.attributeMap.hasOwnProperty(aKey)) {
			switch (aKey) {
				case "role":
					this._text.setAttribute(aKey, this.attributeMap[aKey]);
					break;
				default:
					this._div.setAttribute(aKey, this.attributeMap[aKey]);
			}
		}
	}
};

/**
 * setText
 *
 * $type TFun([{ name => val, t => TInst(String,[]), opt => false }],TEnum(Void,[]))
 * override 	private function setText(val:String):Void
 * @override
 * @private
 * @this com.inq.ui.Text
 * @param {string}  val 
 * @return {void}
 */
com.inq.ui.Text.prototype.setText = function(val) {
	if (this._updatable) {
		this._text.innerHTML = val;
	}
};

/**
 * Returns value of Text instance.
 * @returns {string}
 */
com.inq.ui.Text.prototype.getText = function() {
	return this.getStyle("text");
};

com.inq.ui.Text.prototype.replaceTextOntoElement = function(replacer, element) {
	var text = this._text.childNodes[0].nodeValue;
	var index = text.indexOf(replacer);
	if (index != -1) {
		var startText = text.slice(0, index);
		var endText = text.slice(index + replacer.length);
		this._text.childNodes[0].nodeValue = startText;
		this._text.appendChild(element);
		this._text.appendChild(document.createTextNode(endText));
		this._updatable = false;
	}
};

com.inq.ui.Text.prototype.applyStyle = function(){
	com.inq.ui.Container.prototype.applyStyle.call(this);
	var id = this._div.id.toLowerCase();
	if(navigator.userAgent.indexOf("MSIE 7")>=0 || id.indexOf('failedsend')>=0 || id.indexOf('successsend')>=0){

		if(id.indexOf('emailtitle')>=0 || id.indexOf('emaildescription')>=0 || id.indexOf('failedsend')>=0 || id.indexOf('successsend')>=0){
			try{
				var _s = this._div.style;
				if(this.styles.bottom) {
					_s.top = (-(parseInt(this.styles.bottom) + this._text.offsetHeight)) + "px";
				} else {
					_s.top = parseInt(_s.top) + this._div.clientHeight - this._text.offsetHeight + "px";
				}
			}catch(e){
				haxe.Log.trace("com.inq.ui.Text::applyStyle:"+e , { fileName: "Text.js", lineNumber: 50, className: "com.inq.ui.Text", methodName: "applyStyle"});
			}
		}
	}

};

